export default __webpack_public_path__ + "9a0159e0cb31f827fc1e0b39e7a20a67.svg";